import { clsx } from 'external/clsx'
import { FC, Link, useLocation, useMemo } from 'external/react'

const CancelButton: FC = () => {

	const location = useLocation()

    const [hide, label] = useMemo(() => {
        if (['/', '/offers'].indexOf(location.pathname) >= 0) return [true, '']
        return [false, location.pathname === '/summary' ? 'Salir' : 'Cancelar']
    }, [location.pathname])

	return (
        <li className={clsx('nav-item', 'me-4', {'d-none': hide})}>
            <Link className='btn btn-outline-purple' to='/'>
                {label}
            </Link>
        </li>
	)
}

export default CancelButton
